import { useRef, useEffect } from "react"

export default function LessonGeneratePanel({
  lessons,
  selected,
  setSelected
}) {

  const toggleFile = (id) => {
    setSelected(prev =>
      prev.includes(id)
        ? prev.filter(x => x !== id)
        : [...prev, id]
    )
  }

  const toggleAll = () => {
    const allFiles = lessons.flatMap(l => l.attachments || [])

    if (!allFiles.length) return

    if (selected.length === allFiles.length) {
      setSelected([])
    } else {
      setSelected(allFiles.map(f => f.id))
    }
  }

  const toggleLesson = (lesson) => {
    const ids = (lesson.attachments || []).map(a => a.id)

    const allSelected = ids.every(id => selected.includes(id))

    if (allSelected) {
      // เอาออกทั้งหมดใน lesson นี้
      setSelected(prev => prev.filter(id => !ids.includes(id)))
    } else {
      // เพิ่มทั้งหมดใน lesson นี้
      setSelected(prev => [...new Set([...prev, ...ids])])
    }
  }

  const totalToken = lessons
    .flatMap(l => l.attachments || [])
    .filter(f => selected.includes(f.id))
    .reduce((sum, f) => sum + (parseInt(f.token, 10) || 0), 0)

  return (
    <div className="bg-white rounded-xl p-5 shadow space-y-4">

      <div className="flex items-center justify-between">
        <h3 className="font-semibold text-lg">
          เนื้อหาสำหรับสร้างข้อสอบ
        </h3>
      </div>

      <label className="flex items-center gap-2 text-sm">
        <input
          type="checkbox"
          onChange={toggleAll}
          checked={
            selected.length > 0 &&
            selected.length === lessons.flatMap(l => l.attachments || []).length
          }
        />
        เลือกทั้งหมด
      </label>

      <div className="space-y-3 max-h-64 overflow-y-auto">

        {lessons.map(lesson => {
          const ids = (lesson.attachments || []).map(a => a.id)
          const selectedCount = ids.filter(id => selected.includes(id)).length
          const allChecked = selectedCount === ids.length && ids.length > 0
          const isPartial = selectedCount > 0 && selectedCount < ids.length

          const lessonCheckboxRef = useRef()

          useEffect(() => {
            if (lessonCheckboxRef.current) {
              lessonCheckboxRef.current.indeterminate = isPartial
            }
          }, [isPartial])

          return (
            <div key={lesson.lesson_id}>

              {/* Lesson Header */}
              <label className="flex items-center gap-2 font-medium text-sm text-gray-700 mb-2">
                <input
                  type="checkbox"
                  ref={lessonCheckboxRef}
                  checked={allChecked}
                  onChange={() => toggleLesson(lesson)}
                />
                {lesson.lesson_name}
              </label>

              {/* Attachments */}
              {(lesson.attachments || []).map(att => (
                <label
                  key={att.id}
                  className="flex items-center justify-between border rounded-lg px-3 py-2 text-sm mb-2 ml-6"
                >
                  <div className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      checked={selected.includes(att.id)}
                      onChange={() => toggleFile(att.id)}
                      disabled={!att.is_summarized}
                    />
                    {att.name}
                  </div>

                  {att.is_summarized ? (
                    <span className="text-green-600 text-xs">
                      {/* 🧠 {(att.token / 100).toLocaleString()} */}
                      สรุปแล้ว
                    </span>
                  ) : (
                    <span className="text-gray-400 text-xs">
                      ยังไม่สรุป
                    </span>
                  )}
                </label>
              ))}

            </div>
          )
        })}

      </div>

      <div className="text-sm flex justify-between border-t pt-3">
        <span>เลือกแล้ว {selected.length} รายการ</span>
      </div>

    </div>
  )
}
